import React, { useState, useEffect } from 'react';
import {
    FormControl, FormLabel, FormControlLabel, Radio, RadioGroup, Paper,
    Unstable_Grid2 as Grid, Box, TextField, IconButton, Icon, Switch
} from '@mui/material';
import useWindowFocus from 'use-window-focus';
import http from "../../util/data";
import Poll from './Poll';


export default function Clipboard() {
    const useClipboard = require('react-hook-clipboard').default;
    const [activeRead, setActiveRead] = useState(false);
    const [activeWrite, setActiveWrite] = useState(false);
    const [list, setList] = useState(['_default']);
    const [curr, setCurr] = useState(0);
    const [content, setContent] = useState('');
    const [newName, setNewName] = useState('');
    const [clipboard, copyToClipboard] = useClipboard({});
    const [pending, setPending] = useState(false);
    const tabFocused = useWindowFocus();
    useEffect(()=> {
        if (tabFocused && pending) {
            copyToClipboard(content);
        }
    }, [content, tabFocused, pending, copyToClipboard]);
    useEffect(() => {
        http.get('clipboard/names').then((response) => {
            setList(response.data);
            if (response.data.length > 0) {
                setCurr(0);
            }
        });
    }, []);
    useEffect(() => {
        if (curr === 0 && activeRead && clipboard.length > 0) {
            setContent(clipboard);
            http.post(`clipboard/_default`, clipboard);
        }
    }, [clipboard, activeRead, curr]);
    useEffect(() => {
        if (list.length > 0 && curr >= 0) {
            http.get(`clipboard/${list[curr]}`).then((response) => {
                setContent(response.data);
            });
        }
    },[curr, list, setContent]);
    const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const idx: number = +event.target.value;
        setCurr(idx);        
    };

    const handleChange = (setter: (val: any) => void) => (event: React.ChangeEvent<HTMLInputElement>) => {
        setter(event.target.value);
    }

    const handleActiveReadChange = (event: any, checked: boolean) => {
        if (checked) copyToClipboard('', () => setActiveRead(checked));
        else setActiveRead(checked);
    };
    const handleActiveWriteChange = (event: any, checked: boolean) => {
        setActiveWrite(checked);
        if (curr === 0) copyToClipboard(content);
    };
    const onPoll = async () => {
        const r = await http.get('clipboard/ping');
        if (r.data === true) {
            http.get(`clipboard/${list[0]}`).then((response2) => {
                setContent(response2.data)
                copyToClipboard(response2.data, () => {},
                () => setPending(true));               
            });
        }
    }
    const clickCopy = () => {
        copyToClipboard(content);
    };

    const clickPaste = () => {
        setContent(clipboard);
    };
    const clickDelete = () => {
        http.delete(`clipboard/${list[curr]}`);
        list.splice(curr, 1)
        setList([...list]);
        setCurr(0);
    };
    const clickSave = () => {
        if (curr === -1) {
            http.post(`clipboard/${newName}`, content);
            setList([...list,newName]);
            setCurr(list.length);
            setNewName('');
        } else {
            http.post(`clipboard/${list[curr]}`, content);
        }
    };
    return <div>
        <Box p={10}>
            <Grid container spacing={2} columns={10}>
                <Grid xs={3}>
                    <FormControlLabel
                        value={activeRead}
                        control={<Switch color="warning" />}
                        label="Active read"
                        labelPlacement="end"
                        onChange={handleActiveReadChange}
                    />
                </Grid>
                <Grid xs={3}>
                    <FormControlLabel
                        value={activeWrite}
                        control={<Switch color="warning" />}
                        label="Active write"
                        labelPlacement="end"
                        onChange={handleActiveWriteChange}
                    /></Grid>
                <Grid xs={4}>{curr === 0 && activeWrite && <Poll onPoll={onPoll} />}
                </Grid>

                <Grid xs={2}>
                    <FormControl>
                        <FormLabel id="demo-radio-buttons-group-label">Clipboards</FormLabel>
                        <RadioGroup
                            aria-labelledby="demo-radio-buttons-group-label"
                            value={curr}
                            name="radio-buttons-group"
                            onChange={handleRadioChange}
                        >
                            {list.map((name: string, index: number) =>
                                <FormControlLabel key={index} value={index} control={<Radio />} label={name} />
                            )}
                            <FormControlLabel value={-1} control={<Radio />} label={<TextField variant="standard"
                                value={newName} onChange={handleChange(setNewName)} />} />
                        </RadioGroup>
                    </FormControl>
                </Grid>
                <Grid xs={6}>
                    <Paper >
                        <Box p={2}>
                            <TextField label="Content"
                                sx={{ width: '100%' }}
                                multiline
                                rows={4}
                                value={content}
                                variant="standard"
                                onChange={handleChange(setContent)}
                            />
                        </Box>
                    </Paper>
                </Grid>
                <Grid container xs={2}>
                    <Grid xs={5}>
                        <IconButton aria-label='copy' onClick={clickCopy} color="primary">
                            <Icon sx={{ fontSize: 24 }} baseClassName="fas" className='fa-copy' />
                        </IconButton></Grid>
                    <Grid xs={4}>
                        <IconButton aria-label='paste' onClick={clickPaste} color="primary">
                            <Icon sx={{ fontSize: 24 }} baseClassName="fas" className='fa-paste' />
                        </IconButton></Grid>
                    <Grid xs={5}>
                        <IconButton aria-label='save' onClick={clickSave} color="primary"  disabled={curr === -1 && newName.length === 0}>
                            <Icon sx={{ fontSize: 24 }} baseClassName="fas" className='fa-save' />
                        </IconButton></Grid>
                        <Grid xs={5}>
                        <IconButton aria-label='save' onClick={clickDelete} color="error"  disabled={curr === -1}>
                            <Icon sx={{ fontSize: 24 }} baseClassName="fas" className='fa-trash' />
                        </IconButton></Grid>
                </Grid>
            </Grid>
        </Box>
    </div>
}
